import TAvatar from './avatar.vue'

TAvatar.install = Vue => {
  Vue.component(TAvatar.name, TAvatar)
}

export default TAvatar



// WEBPACK FOOTER //
// ./src/module/avatar/index.js